import { memo, type FC } from 'react';

import { LabelWrapper, Wrapper } from './styled.ts';
import type { TableNoteProps } from './types.ts';

export const TableNote: FC<TableNoteProps> = memo(function TableNote({ label, value, dataTestId }) {
  return (
    <Wrapper data-testid={dataTestId}>
      <LabelWrapper>{label}</LabelWrapper>
      {value}
    </Wrapper>
  );
});
